var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.75 10.0002H24.925C24.4886 8.84377 23.8106 7.79377 22.9363 6.9202L18.5813 2.5627C17.7066 1.68936 16.6563 1.01184 15.5 0.575195V8.7502C15.5 9.44049 16.0596 10.0002 16.75 10.0002Z",
    fill: "#68B859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.47 12.5H16.75C14.6789 12.5 13 10.821 13 8.74998V0.03C12.7987 0.0162305 12.5975 0 12.3937 0H6.74996C3.2999 0.00416016 0.504102 2.79996 0.5 6.25002V23.75C0.504102 27.2 3.2999 29.9959 6.74996 30H19.2499C22.7 29.9959 25.4958 27.2 25.5 23.75V13.1062C25.5 12.9025 25.4837 12.7012 25.47 12.5Z",
    fill: "#68B859"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSmall);
export default __webpack_public_path__ + "static/media/file-small.39541ac495b7798b45c3ddeec70d4375.svg";
export { ForwardRef as ReactComponent };